import React, { ReactElement, ReactNode } from 'react';

import useFeatureToggleService from 'feature-toggle';
import styles from './InnerBlock.module.scss';
import { useShowContext } from 'ui-builder';
import ShadcnInnerBlock from './ShadcnInnerBlock';

export interface InnerBlockProps {
  title: string | ReactElement | ((data: any) => string | ReactElement),
  titleLine2?: ReactNode,
  headerRight?: ReactNode,
  children: ReactNode,
  showHeaderBorder?: boolean
  className?: string
  testId?: string
  headerSize?: 1 | 2 | 3 | 4 | 5 | 6
}

function BlockTitle(props: {
  headerSize: 1 | 2 | 3 | 4 | 5 | 6,
  children: ReactNode,
}) {
  const Header = `h${props.headerSize}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return(
    <Header>{props.children}</Header>
  );
}

function LegacyInnerBlock(props: InnerBlockProps) {

  const showContext = useShowContext();

  function getTitle() {
    if (typeof props.title !== 'function') {
      return props.title;
    } else {
      return props.title(showContext?.data || {});
    }
  }

  return (
    <div className={`${styles.block} ${props.className}`} data-testid={props.testId}>
      <div className={`${styles.header} ${props.showHeaderBorder ? styles.bordered : ''}`}>
        {props.headerRight && (
          <div className={styles.buttons}>
            {props.headerRight}
          </div>
        )}
        <BlockTitle headerSize={props.headerSize || 2}>
          {getTitle()}
        </BlockTitle>
        {props.titleLine2 && (
          <div className={styles.line2}>
            {props.titleLine2}
          </div>
        )}
      </div>
      <div className={styles.content}>
        {props.children}
      </div>
    </div>
  );
}

export default function InnerBlock(props: InnerBlockProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnInnerBlock {...props} />;
  } else {
    return <LegacyInnerBlock {...props} />;
  }
}
